import { useRef } from "react";
import { Button, cn } from "@tellescope/ui";
import { useSidebarPanel } from "./useSidebarPanel";
import { PAGE_HEADER_SIZE_STRING } from "../../constants/header-sizing";
import { X } from "lucide-react";
import { useShallowSidebarStore } from "../../store/sidebar-store";
import { SIDEBAR_PANEL_HEADER_CONTENT_COMPONENT_MAP } from "./sidebar-panel-header-content-component-map";
import { useTranslation } from "react-i18next";
import { SIDEBAR_PANEL_CONTENT_COMPONENT_MAP } from "./sidebar-panel-content-component-map";

export const SidebarPanel = () => {
  const { t } = useTranslation("sidebar");
  const panelRef = useRef<HTMLElement>(null);
  const { contentType, contentTypeData } = useShallowSidebarStore("contentType", "contentTypeData");
  const { isOpen, width, onDragStart, toggleIsOpen } = useSidebarPanel(panelRef);

  const HeaderContentComponent = contentType ? SIDEBAR_PANEL_HEADER_CONTENT_COMPONENT_MAP[contentType] : null;
  const ContentComponent = contentType ? SIDEBAR_PANEL_CONTENT_COMPONENT_MAP[contentType] : null;
  const data = contentType ? contentTypeData[contentType] : undefined;

  return (
    <aside
      ref={panelRef}
      className={cn(
        "relative border-l border-l-gray-200 h-svh transition-[width] flex-shrink-0 overflow-hidden flex flex-col",
        isOpen ? "" : "w-0 overflow-hidden"
      )}
      style={isOpen ? { width } : undefined}
    >
      {isOpen && (
        <>
          <div className="absolute left-0 top-0 h-full w-1 cursor-col-resize " onMouseDown={onDragStart} />
          <div
            className="absolute left-0.5 top-[50%] bottom-[50%] w-0.5 h-10 rounded-full bg-gray-200 cursor-col-resize hover:bg-blue-400/50 active:bg-blue-400/70 transition-colors"
            onMouseDown={onDragStart}
          />
        </>
      )}
      <div
        className={`border-b border-b-gray-200 h-[${PAGE_HEADER_SIZE_STRING}] flex justify-between items-center px-4 py-2`}
      >
        {HeaderContentComponent ? <HeaderContentComponent /> : <div />}
        <div className="flex gap-1 items-center">
          <Button variant="ghost" size="icon" onClick={toggleIsOpen} hoverLabel={t("Close sidebar")}>
            <X />
          </Button>
        </div>
      </div>
      <div className="flex flex-col flex-grow p-4 overflow-y-hidden">
        {ContentComponent && !!data ? <ContentComponent {...data} /> : null}
      </div>
    </aside>
  );
};
